export default "__VITE_ASSET__H6G9ntWU__"